import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { ColumnEditorOptions } from "primereact/column";

export const PriorityEditor =
    (enableLowPriorityDefects: boolean) => (options: ColumnEditorOptions) => {
        const priorityOptions = [
            { label: "High", value: 2 },
            { label: "Medium", value: 3 }
        ];

        if (enableLowPriorityDefects) {
            priorityOptions.push({ label: "Low", value: 5 });
        }

        const onChange = (event: DropdownChangeEvent) => {
            if (options.editorCallback) {
                options.editorCallback(event.target.value);
            }
        };

        return (
            <Dropdown
                value={options.value}
                onChange={onChange}
                options={priorityOptions}
                scrollHeight="400px"
            />
        );
    };
